const stats = [
  { number: "35+", label: "Active Members" },
  { number: "25+", label: "Years on the Road" },
  { number: "", label: "State Chapters" },
  { number: "100%", label: "Brotherhood" },
];

export default function AboutSection() {
  return (
    <section id="about" className="w-full bg-[#111111] py-24 px-6 lg:px-20">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row gap-16 items-center">
          {/* Image */}
          <div className="w-full lg:w-1/2">
            <div className="relative">
              <div className="w-full h-[480px] overflow-hidden">
                <img
                  src="https://static.readdy.ai/image/0b053ca972f96e6a72462b3430aa5d72/296f873bfe29df2ded7f1b78f6c3abbc.jpeg"
                  alt="About the Club"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="absolute -bottom-4 -right-4 bg-red-700 w-32 h-32 flex items-center justify-center flex-col">
                <span className="text-white font-black text-3xl" style={{ fontFamily: "'Bebas Neue', sans-serif" }}>EST</span>
                <span className="text-white font-black text-3xl" style={{ fontFamily: "'Bebas Neue', sans-serif" }}>2025</span>
              </div>
            </div>
          </div>

          {/* Content */}
          <div className="w-full lg:w-1/2">
            <p className="text-red-500 uppercase tracking-[0.3em] text-xs font-bold mb-4">Who We Are</p>
            <h2 className="text-4xl md:text-5xl font-black text-white uppercase mb-6" style={{ fontFamily: "'Bebas Neue', sans-serif" }}>
              More Than a Club.<br />
              <span className="text-red-600">A Brotherhood.</span>
            </h2>
            <p className="text-gray-400 text-base leading-relaxed mb-6">
              Respect Motorcycle Club founded in 2026, we are free riders, riding anything from Cruisers, Crotch Rockets, Trikes, Can Am 3 Wheel Motorcycles Ect... We have a Social Club for non riders, and a Auto Club for those prefer the car life. Please feel free to contact us for details on joining our growing family.
            </p>
            <p className="text-gray-400 text-base leading-relaxed mb-10">
              Our members come from all walks of life, united by the rumble of an engine and the open road. 
              We ride together, support each other, and give back to our communities. If you share our values, 
              the road is calling you home.
            </p>

            {/* Stats */}
            <div className="grid grid-cols-2 gap-6">
              {stats.map((stat) => (
                <div key={stat.label} className="border-l-4 border-red-600 pl-4">
                  <div className="text-3xl font-black text-white" style={{ fontFamily: "'Bebas Neue', sans-serif" }}>{stat.number}</div>
                  <div className="text-gray-500 text-sm uppercase tracking-wider">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
